import React from "react";
import Modal from "react-modal";

Modal.setAppElement("#root"); // important for accessibility

const PDFModal = ({ isOpen, onClose, pdfUrl }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          width: "80%",
          height: "80%",
          margin: "auto",
          padding: "10px",
        },
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
         <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
              <h3>View PDF</h3>
         <div style={{ marginTop: "10px", textAlign: "right" }}>
        <a href={pdfUrl} download className="primary-button hidden-tablet">
          ⬇ Download PDF
        </a>
      </div>
         </div>
        <button className="close-ddf" onClick={onClose}>✕</button>
      </div>

      {/* PDF Viewer */}
      <iframe
        src={pdfUrl}
        title="PDF Viewer"
        width="100%"
        height="90%"
        style={{ border: "none" }}
      />

      {/* Download Button */}
     
    </Modal>
  );
};

export default PDFModal;
